module.exports = {
  tag: require('./flv-tag'),
  Transmuxer: require('./transmuxer'),
  tools: require('../tools/flv-inspector'),
};
